(function () {
    'use strict';

    var app = angular.module('inoApp');
    function tabstripController($scope, $timeout) {
        var vm = this;

        // This array keeps track of the tabstrips
        vm.tabs = [];
        vm.tabRoot = null;
        vm.resetTabStrip = resetTabStrip;
        vm.resetTrigger = null;
        vm.addTab = addTab;
        vm.removeGroup = removeGroup;
        vm.activate = activate;

        activate();
        function activate() {
            $timeout(function () {
                vm.tabs.forEach(function (tabScope) {
                    angular.element(vm.tabRoot).find("#" + tabScope.tabId).append(tabScope.tabContent);
                    angular.element(vm.tabRoot).find(".tabheader[href='#" + tabScope.tabId + "']").append(tabScope.tabHeader);
                });
                if (vm.resetTrigger !== null)
                    $scope.$watch('resetTrigger', function () {
                        vm.resetTabStrip();
                    });
            });
        }
        function resetTabStrip() {
            // allow time for rendering
            $timeout(function () {
                for (var iCnt = 0; iCnt < vm.tabs.length; iCnt++) {
                    if (!vm.tabs[iCnt].isHidden) {
                        angular.element(vm.tabRoot).find(".tabheader[href='#" + vm.tabs[iCnt].tabId + "']").click();
                        break;
                    }
                }
            });
        }
        function addTab(tabScope) {
            vm.tabs.push(tabScope);
            tabScope.$on('$destroy', function (event) {
                vm.removeGroup(tabScope);
            });
        };
        function removeGroup(tabScope) {
            var index = vm.tabs.indexOf(tabScope);
            if (index !== -1) {
                vm.tabs.splice(index, 1);
            }
        };
    }
    app.controller("TabstripController", ['$scope', '$timeout', tabstripController
    ]).directive('tabstrip', ['config', '$rootScope', function (config, $rootScope) {
        return {
            replace: true,
            transclude: true,
            scope: {
                resetTrigger: "="
            },
            restrict: 'E',
            controller: 'TabstripController as vm',
            templateUrl: 'templates/core/layout/tabstrip.html',
            link: link
        };

        function link(scope, iElement, iAttrs, controller) {
            scope.vm.tabRoot = angular.element(iElement[0]);
            scope.vm.resetTrigger = scope.resetTrigger;
        }
    }
    ]).directive('tabstripGroup', [function () {
        return {
            replace: false,
            transclude: true,
            require: '^tabstrip',
            restrict: 'E',
            scope: {
                tabHeader: '&',
                tabContent: '&',
                tabId: '@',
                isHidden: '='
            },
            controller: ['$scope', function ($scope) {
                this.setTabHeader = function (element) {
                    $scope.tabHeader = element;
                };
                this.setTabContent = function (element) {
                    $scope.tabContent = element;
                };
            }],
            template: '<div ng-transclude></div>',
            link: link
        };
        function link(scope, iElement, iAttrs, controller) {
            controller.addTab(scope);
        }
    }
    ]).directive('tabstripHeader', [function () {
        return {
            replace: false,
            require: '^tabstripGroup',
            transclude: true,
            restrict: 'E',
            template: '<div ng-transclude></div>',
            link: {
                post: postlink
            },
        };
        function postlink(scope, iElement, iAttrs, controller, transcludeFn) {
            transcludeFn(function (clone, scope) {
                controller.setTabHeader(clone);
                angular.element(iElement[0]).remove(); // remove from DOM
            });

        }
    }
    ]).directive('tabstripContent', [function () {
        return {
            replace: false,
            require: '^tabstripGroup',
            transclude: true,
            restrict: 'E',
            template: '<div ng-transclude></div>',
            link: {
                post: postlink
            },
        };
        function postlink(scope, iElement, iAttrs, controller, transcludeFn) {
            transcludeFn(function (clone, scope) {
                controller.setTabContent(clone);
                angular.element(iElement[0]).remove(); // remove from DOM
            });


        }
    }]);
})();